export default __webpack_public_path__ + "static/media/email_icon.a0bb4392.png";